<template>
  <div class="container ">
    <div class="container scroll-box" style="overflow: scroll;" id="scrollBoxCollege"  @mousewheel="debounce">
      <div class="container" id="collegeFirst"  v-if="$store.state.isPc">
          <!-- <transition name="fold">-->
          <div class="left " >
            <div class="item-box flexHC" v-if="currentIndex == 4"  :class="currentIndex == 4 ? 'foldA' :''">
              <img :src="itemImg1" class="item-img marL32">
              <div class="marL25 ">
                <div class="item-title">Mr.Boogie — 不想做什么都无疾而终</div>
                <div class="item-intro marT15">“谢谢镜子里的你呀 ，陪伴我走过本应贫瘠的路 ” 这是Mr.Boogie在完成两个100天计划之后与自己的对话。</div>
              </div>
            </div>
            <div class="item-box marT32 flexHC" v-if="currentIndex == 4"  :class="currentIndex == 4 ? 'foldB' :''" >
              <img :src="itemImg2" class="item-img  marL32">
              <div class="marL25  ">
                <div class="item-title">七月 — 我在武汉</div>
                <div class="item-intro marT15">在焦躁了一段时间之后，七月愈发觉得，陷于疫情的焦虑是没用的，只有健身，把压抑的情绪都发泄出来，让自己动起来，整个人才会真正开心。</div>
              </div>
            </div>
            <div class="item-box marT32 flexHC" v-if="currentIndex == 4"  :class="currentIndex == 4 ? 'foldC' :''">
              <img :src="itemImg3" class="item-img  marL32">
              <div class="marL25 ">
                <div class="item-title">薄荷 — 35+的人生：健身、骑马、玩滑板</div>
                <div class="item-intro marT15">有些路注定要自己走，要享受生命里的高光时刻，就要身披铠甲披荆斩棘。</div>
              </div>
            </div>
          </div>
          <!-- </transition>-->
        <div class="right flexVR pR">
          <div style="width: 260px;height: 90px;" class="pR flexVC">
            <div class="title">优秀学员</div>
            <div class="w100 pR title-line-box">
              <div class="titleLine"></div>
              <div class="titleLine-animation"
                   :class="currentIndex == 4 ? 'titleLine-animation-index' : '' "></div>
            </div>
          </div>
          <div class="content">{{content}}</div>
          <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave" @click="moreClick">
            <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
            </div>
            <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
              <span>了解更多</span>
              <img :src="isHover ? whiteArrow : arrow"
                   style="width: 15px;height: 11px;margin-left: 5px;">
            </div>
          </div>
          <div class="btn-wx-app flexHC2"  @mouseenter="codeEnter" @mouseleave="codeLeave">
            <span>趁早行动</span>
            <img src="../../../assets/images/icon_wx_app.png"
                 style="width: 13.5px;height: 13px;margin-left: 5px;margin-top: 2px;">
          </div>
          <div class="flexVC code-box" v-show="isShowCode">
            <div class="code-content flexVC2">
              <img src="../../../assets/images/icon_wx_app_code.jpg"
                   style="width: 103px;height: 103px;margin-left: 5px;margin-top: 2px;">
              <span style="margin-top: 18px;">微信扫一扫</span>
            </div>
          </div>
          <!--      <div style="font-size: 20px;">-->
          <!--        <button @click="show = !show">show</button>-->
          <!--      </div>-->
        </div>
        <div style="height: 60px;"></div>
      </div>
      <div class="container-m pR flexVC2" v-if="!$store.state.isPc">
        <!--      <div style="height: 13.9%;"></div>-->
        <div style="width: 1.9rem;height: 0.6rem;" class="pR flexVC">
          <div class="title-m">优秀学员</div>
          <div class="w100 pR title-line-box-m">
            <div class="titleLine-m"></div>
            <div class="titleLine-animation-m"
                 :class="currentIndex == 4 ? 'titleLine-animation-index-m' : '' "></div>
          </div>
        </div>
        <div class="content-m flexHC2" style="margin-top: 0.4rem;">他们都是趁早精神的见证者，也是践行者 </div>
        <div class="content-m flexHC2">我们共同生活在趁早星球，我们砥砺前行</div>
        <div class="flexHC">
          <div class="btn-more-box-m flexHC2"  @click="moreClick">
            <span>了解更多</span>
            <img :src="isHover ? whiteArrow : arrow"
                 style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
          </div>

          <div class="btn-more-box-m flexHC2" style="margin-left: 0.32rem;" @click="showModal">
            <span>趁早行动</span>
            <img :src="isHover ? whiteArrow : arrow"
                 style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
          </div>
        </div>

        <div class="item-box-m  flexV" v-if="currentIndex == 4" style="margin-top: 0.8rem;"
             :class="currentIndex == 4 ? 'foldA' :''">
          <img :src="itemImg1" class="item-img-m   ">
          <div class="item-title-m marT15m">Mr.Boogie — 不想做什么都无疾而终</div>
          <div class="marL32m">
            <div class="item-intro-m marT10m">“谢谢镜子里的你呀 ，陪伴我走过本应贫瘠的路 ” 这是Mr.Boogie在完成两个100天计划之后与自己的对话。</div>
          </div>
        </div>
        <div class="item-box-m marT40m flexV" style="width: 6.22rem;" v-if="currentIndex == 4"
             :class="currentIndex == 4 ? 'foldB' :''">
          <img :src="itemImg2" class="item-img-m   ">
          <div class="item-title-m marT15m">七月 — 我在武汉</div>
          <div class="marL32m">
            <div class="item-intro-m marT10m">在焦躁了一段时间之后，七月愈发觉得，陷于疫情的焦虑是没用的，只有健身，把压抑的情绪都发泄出来，让自己动起来，整个人才会真正开心。</div>
          </div>
        </div>
        <div class="item-box-m marT40m flexV" v-if="currentIndex == 4"
             :class="currentIndex == 4 ? 'foldC' :''">
          <img :src="itemImg3" class="item-img-m   ">
          <div class="item-title-m marT15m">薄荷 — 35+的人生：健身、骑马、玩滑板</div>
          <div class="marL32m ">
            <div class="item-intro-m marT10m">有些路注定要自己走，要享受生命里的高光时刻，就要身披铠甲披荆斩棘。</div>
          </div>
        </div>
        <div style="height: 60px;"></div>
        <code-modal :codeImg="currentCodeData.codeImg" :title="currentCodeData.nickname" :type="1"
                    :subtitle="currentCodeData.tips"  @closeModal="closeModal" v-show="isShowModal"></code-modal>
      </div>
      <shape-footer></shape-footer>
    </div>
  </div>
</template>

<script>

  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'
  import shapeFooter from '@/components/ShapeFooter'
  import codeImg from '@/assets/images/icon_wx_app_code.jpg'
  import codeModal from '@/components/CodeModal'

  export default {
    name: "CollegeFourth",
    props: ["currentIndex"],
    data() {
      return {
        isHover: false,
        isShowCode: false,
        content: '他们都是趁早精神的见证者，也是践行者，我们共同生活在趁早星球，我们砥砺前行',
        whiteArrow: whiteArrow,
        arrow: arrow,
        itemImg1: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/icon_college_excellent_1.png',
        itemImg2: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/icon_college_excellent_2.png',
        itemImg3: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/icon_college_excellent_3.png',
        isShowModal:false,
        currentCodeData: {
          codeImg: codeImg,
          nickname: '',
          tips: '请扫码查看',
        },
        show: true
      }
    },

    components: {
      shapeFooter,
      codeModal,
    },

    mounted() {
    },

    watch: {
      currentIndex(val) {
      }
    },

    methods: {
      closeModal(){
        this.isShowModal = false
      },
      showModal(){
        this.isShowModal = true
      },
      debounce(e) {
        console.log('debounce-----------------debounce------------',e)

        var testDiv = document.getElementById('scrollBoxCollege');
        var divScrollTop = testDiv.scrollTop;
        var divClientHeight = testDiv.clientHeight;
        var divScrollHeight = testDiv.scrollHeight;
        if (divScrollTop + divClientHeight >= divScrollHeight && e.wheelDelta < 0) {
          console.log('到底部了');
          // this.$emit('scrollListener', '1')
        }
        if (divScrollTop == 0  && e.wheelDelta > 0) {
          console.log('到顶部了');
          this.$emit('scrollListener', '1')
        }
        // document.getElementById('scrollBox').scrollTop = 150 * 10;
        // document.getElementById('scrollBox').scrollLeft = 150 * 10;
      },
      moreClick(){
        window.open('https://mp.weixin.qq.com/mp/appmsgalbum?action=getalbum&__biz=MjM5NTI0ODQwMQ==&scene=1&album_id=1409237001353936896#wechat_redirect','_blank')
      },
      codeEnter() {
        this.isShowCode = true
      },
      codeLeave() {
        this.isShowCode = false
      },
      moreEnter(e) {
        this.isHover = true
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },
  }
</script>

<style scoped>

  #collegeFirst {
    background-image: url("../../../assets/images/bg_college_fourth.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

  }

  .left {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    padding-left: 7.71vw;
  }

  .logo {
    width: 90px;
    height: 90px;
  }

  .title {
    width: 260px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -130px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 245px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 28px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    max-width: 450px;
    min-width: 240px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-top: 60px;
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    /*overflow: hidden;*/
  }

  .btn-wx-app {
    width: 230px;
    height: 51px;
    background: #D70050;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    margin-top: 15px;
  }

  .code-box {
    width: 250px;
    left: 50%;
    margin-top: 20px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    bottom: -188px;
  }

  .code-content{
    width: 120px;
    height: 168px;
    background: #FFFFFF;
    background: url("../../../assets/images/bg_code.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /*border: 2px solid rgba(0, 0, 0, 0.04);*/
  }

  .right {
    position: absolute;
    right: 15vw;
    top: 50%;
    transform: translate(0, -50%);
  }

  .item-box {
    width: 610px;
    height: 156px;
    background: #FFFFFF;
    box-shadow: 0px 10px 38px 13px rgba(0, 0, 0, 0.02), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.04);
    border-radius: 6px;
    opacity: 0;
  }

  .item-img {
    width: 84px;
    height: 84px;
  }

  .item-title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  .item-tag {
    width: auto;
    height: 22px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding: 0 6px;
    color: rgba(0, 0, 0, 0.65);
  }

  .item-intro {
    width: 354px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);

  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    margin-top: 60px;
    border: 1px solid #000000;
    color: #000000;
    position: relative;
    cursor: pointer;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      width: 100%;
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      width: 0px;
      -webkit-transform: translateX(245px);
    }
  }

  @keyframes spin {
    from {
      width: 100%;
      transform: translateX(0px);
    }
    to {
      width: 0px;
      transform: translateX(245px);
    }

  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }

  .foldA {
    animation-name: fold-in;
    animation-duration: 1.5s;
    animation-delay: 0.2s;
    animation-fill-mode: forwards;
  }
  .foldB {
    animation-name: fold-in2;
    animation-duration: 1.6s;
    animation-delay: 0.4s;
    animation-fill-mode: forwards;
  }
  .foldC {
    animation-name: fold-in3;
    animation-duration: 1.7s;
    animation-delay: 0.6s;
    animation-fill-mode: forwards;
  }

  /*.fold-enter-active {*/
  /*  animation-name: fold-in;*/
  /*  animation-duration: 1.8s;*/
  /*  animation-delay: 0.2s;*/
  /*  animation-fill-mode: forwards;*/
  /*}*/

  .fold-leave-active {
    animation-name: fold-out;
    animation-duration: 1.7s;
    animation-delay: 0.6s;
  }


  /*.fold2-enter-active {*/
  /*  animation: fold-in2 2.2s 0.6s linear 1;*/
  /*  animation-name: fold-in2;*/
  /*  animation-duration: 2.2s;*/
  /*  animation-delay: 0.6s;*/
  /*  animation-fill-mode: forwards;*/
  /*}*/

  .fold2-leave-active {
    animation-name: fold-out2;
    animation-duration: 1.6s;
    animation-delay: 0.4s;
  }


  /*.fold3-enter-active {*/
  /*  animation-name: fold-in3;*/
  /*  animation-duration: 2.6s;*/
  /*  animation-delay: 0.9s;*/
  /*  animation-fill-mode: forwards;*/
  /*}*/

  .fold3-leave-active {
    animation-name: fold-out3;
    animation-duration: 1.5s;
    animation-delay: 0.2s;
  }

  @keyframes fold-in {
    0% {
      transform: translateY(300%) scale(.5);
      opacity: 0;
    }
    100% {
      transform: translateY(0%) scale(1);
      opacity: 1;
      /*transform: scale(1);*/
    }
  }

  @keyframes fold-out {
    0% {
      transform: translateY(0%) scale(1);
      /*transform: scale(1);*/
      opacity: 1;
    }
    100% {
      transform: translateY(300%) scale(.5);
      /*transform: scale(.1);*/
      opacity: 0;
    }
  }


  @keyframes fold-in2 {
    0% {
      transform: translateY(200%) scale(.5);
      opacity: 0;
    }
    100% {
      transform: translateY(0%) scale(1);
      opacity: 1;
      /*transform: scale(1);*/
    }
  }

  @keyframes fold-out2 {
    0% {
      transform: translateY(0%) scale(1);
      /*transform: scale(1);*/
      opacity: 1;
    }
    100% {
      transform: translateY(200%) scale(.5);
      /*transform: scale(.1);*/
      opacity: 0;
    }
  }

  @keyframes fold-in3 {
    0% {
      transform: translateY(100%) scale(.5);
      opacity: 0;
    }
    100% {
      transform: translateY(0%) scale(1);
      opacity: 1;
      /*transform: scale(1);*/
    }
  }

  @keyframes fold-out3 {
    0% {
      transform: translateY(0%) scale(1);
      /*transform: scale(1);*/
      opacity: 1;
    }
    100% {
      transform: translateY(100%) scale(.5);
      /*transform: scale(.1);*/
      opacity: 0;
    }
  }


  @media screen and (max-width: 1440px) {

    .item-box {
      width: 510px;
      height: 156px;
      background: #FFFFFF;
      box-shadow: 0px 10px 38px 13px rgba(0, 0, 0, 0.02), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.04);
      border-radius: 6px;
      opacity: 0;
    }

  }



  .flexVR{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }





  @media screen and (max-width: 1300px) {

    .content {
      width: 300px;
      max-width: 350px;
      min-width: 240px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      margin-top: 60px;
    }

  }


  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }


  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    margin-top: 0.48rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }


  .item-box-m {
    width: 6.2rem;
    height: 1.64rem;
    background: #FFFFFF;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.02), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    position: relative;
    opacity: 0;
  }

  .item-img-m {
    width: 0.68rem;
    height:0.68rem;
    position: absolute;
    top: -0.22rem;
    left: 0.32rem;
  }

  .item-title-m {
    font-size: 0.26rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-left: 1.2rem;
  }

  .item-intro-m {
    width: 5.5rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0.28rem;
  }

  .item-tag-m {
    width: auto;
    height: 0.34rem;
    font-size: 0.18rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    margin-right: 0.12rem;
    padding: 0 0.12rem;
  }

  .item-num-m {
    font-size: 0.18rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 0.15rem;
  }


  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marT20m {
    margin-top: 0.2rem;
  }

  .marT15m {
    margin-top: 0.15rem;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  .marT32m {
    margin-top: 0.32rem;
  }

  .marT40m {
    margin-top: 0.4rem;
  }

  .marL32m{margin-left: 0.32rem;}

  .marL20m {
    margin-left: 0.2rem;
  }

  /*  *************************************************************************************/



</style>



// WEBPACK FOOTER //
// src/page/college/components/CollegeFourth.vue